import Vue from 'vue'
import VueApollo from 'vue-apollo';
import {ApolloClient} from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import {createHttpLink} from 'apollo-link-http';
import {onError} from 'apollo-link-error';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {graphQlUrl, graphQlUrlPrisma2} from '@/constants/config';
import store from '@/store';

Vue.use(VueApollo);

const httpLink = createHttpLink({
  uri: graphQlUrl,
  // fetchOptions: {
  //   credentials: 'include',
  // },
});

const httpLinkPrisma2 = createHttpLink({
  uri: graphQlUrlPrisma2
});

const middlewareLink = new ApolloLink((operation, forward) => {
  if (!localStorage.getItem('token') || localStorage.getItem('token') === " ") {
    store.dispatch('User/signOut');
  } else {
    operation.setContext({
      headers: {
        authorization: localStorage.getItem('token'),
        app: process.env.VUE_APP_APP_TYPE || "teacher",
        appname: "xstudi"
      },
    });
  }

  return forward(operation);
});

const errorLink = onError(({graphQLErrors, networkError}) => {
  if (networkError) {
    console.log('[networkError', networkError); // eslint-disable-line no-console
  }

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if(err){
        if (err.code === 401 || err.message === 'AuthenticationError') {
          store.dispatch('User/signOut');
        }
      }
    }
  }
});

const link = errorLink.concat(middlewareLink.concat(httpLink));
const linkPrisma2 = errorLink.concat(middlewareLink.concat(httpLinkPrisma2));

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: ApolloLink.split(
    operation => operation.getContext().clientName === "Prisma2",
    linkPrisma2,
    link
  ),
  cache
});

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});
